export default __webpack_public_path__ + "static/media/menuIcon.ace4568d.svg";